import React from 'react';
import { InfoIcon } from 'lucide-react';
import type { PartnerProfile } from '../../../types/partners';
import { Reveal } from '../../ui/Reveal';
export function PartnerScoresSection({
  scores,
  partnerName
}: {
  scores: NonNullable<PartnerProfile['scores']>;
  partnerName: string;
}) {
  return <section aria-labelledby="scores-heading" className="border-b border-hairline-soft bg-surface" data-id="element-704" data-mp="t5xmxnnaoxe3">
      <div className="mx-auto w-full max-w-[1320px] px-4 py-20 sm:px-6 lg:px-8 lg:py-24" data-id="element-705" data-mp="5gd18wzrbm14">
        <Reveal className="max-w-3xl" data-id="element-706" data-mp="i1tqswxpnm2">
          <p className="text-[11px] font-semibold uppercase tracking-[0.09em] text-[color:var(--pa)]" data-id="element-707" data-mp="j4fynjbb1vn">{scores.eyebrow}</p>
          <h2 id="scores-heading" className="sf-display mt-4 text-balance text-[32px] leading-[1.04] text-text-primary sm:text-[44px]" data-id="element-708" data-mp="f80r4tgo0v0h">
            {scores.headline}
          </h2>
          <p className="mt-4 text-[15px] leading-relaxed text-text-secondary sm:text-base" data-id="element-709" data-mp="3iu817xvfeyu6">{scores.intro}</p>
        </Reveal>

        <ul className="mt-12 grid gap-4 md:grid-cols-3" data-id="element-710" data-mp="3dull9go7r4ho">
          {scores.items.map((score, index) => <Reveal key={score.code} as="li" delay={index * 0.05} className="relative overflow-hidden rounded-2xl border border-hairline bg-panel p-6 sm:p-7" data-id="element-711" data-mp="2ws0joag04ijs" data-mpi={index}>
              <span aria-hidden="true" className="absolute inset-x-0 top-0 h-1 bg-[color:var(--pa)]" data-id="element-712" data-mp="35ngeatokz1qf" />
              <div className="flex items-center justify-between gap-3" data-id="element-713" data-mp="3akq9yr2kc9mp">
                <p className="font-mono text-[34px] font-semibold leading-none tracking-[-0.02em] text-[color:var(--pa)]" data-id="element-714" data-mp="2dvr23d5w59v1">{score.code}</p>
                <span className="rounded-md bg-[color:var(--pa-soft)] px-2 py-0.5 text-[10px] font-semibold uppercase tracking-[0.08em] text-[color:var(--pa)]" data-id="element-715" data-mp="2hwue1oktilqz">
                  {partnerName} methodology
                </span>
              </div>
              <h3 className="mt-5 text-base font-semibold tracking-[-0.015em] text-text-primary" data-id="element-716" data-mp="25y3qehfbgmb">{score.name}</h3>
              <p className="mt-2 text-sm leading-relaxed text-text-secondary" data-id="element-717" data-mp="73q47ww4wb24">{score.description}</p>
            </Reveal>)}
        </ul>

        <div role="note" className="mt-8 flex gap-3 rounded-xl border border-[#F0E0C4] bg-[#FDF7ED] p-4 text-sm leading-relaxed text-[#7C2D12]" data-id="element-718" data-mp="3dnup7ubmk87c">
          <InfoIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-719" data-mp="3nk7iir39ck1k" />
          <p data-id="element-720" data-mp="3il4cp4fge9sj">{scores.disclaimer}</p>
        </div>
      </div>
    </section>;
}